export var FontCategory;
(function (FontCategory) {
    FontCategory["SANS_SERIF"] = "SANS_SERIF";
    FontCategory["DISPLAY"] = "DISPLAY";
    FontCategory["SERIF"] = "SERIF";
    FontCategory["HANDWRITING"] = "HANDWRITING";
    FontCategory["MONOSPACE"] = "MONOSPACE";
})(FontCategory || (FontCategory = {}));
/** Font source - specifies the origin source of the font */
export var FontSource;
(function (FontSource) {
    FontSource["WEBFONTS_WEBFONT"] = "WEBFONTS_WEBFONT";
    FontSource["CUSTOM_FONT"] = "CUSTOM_FONT";
})(FontSource || (FontSource = {}));
//# sourceMappingURL=types.impl.js.map